const Setback = () => {
  return <h1>O.R. Setback</h1>;
};

export default Setback;
